import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { JaneDoeBusinessCardStackBackgroundViewModel } from './jane-doe-business-card-stack-background-view-model';
import { CardBackgroundComponent } from '../../card-background.component';
import type { CardData } from '../../../../../../../models/print-cards/card-data';

@Component({
  selector: 'app-jane-doe-business-card-stack-background',
  templateUrl: './jane-doe-business-card-stack-background.component.html',
  styleUrls: ['./jane-doe-business-card-stack-background.component.scss'],
  providers: [JaneDoeBusinessCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class JaneDoeBusinessCardStackBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public viewModel: JaneDoeBusinessCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: CardData;
}
